import React from 'react';

import SmartImage from 'dpl/components/SmartImage';
import Icon from 'dpl/common/components/Icon';
import { STANDARDS_PATH } from 'dpl/shared/constants/urls';
import { isLessThanBreakpoint } from 'dpl/util/grid';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURE_LOCATIONS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';
import useSearchFiltering from 'dpl/search_result_filters/hooks/useSearchFiltering';

import breederGeoMobilePng from 'dpl/assets/breeder-geo-mobile.png';
import breederGeoDesktopPng from 'dpl/assets/breeder-geo-desktop.png';

import { RESULTS_TYPES } from '../utils/constants';

const IS_LT_LG = isLessThanBreakpoint('lg');
const LINK_COPY = 'What makes a responsible breeder?';

function trackAnalytics(props) {
  sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
    button_cta: LINK_COPY,
    view_feature: ANALYTICS_VIEW_FEATURES.BREEDER_SCREENING_BANNER,
    view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_RESULTS,
    ...props
  });
}

export default function BreederScreeningBanner() {
  const { resultsType } = useSearchFiltering();

  function handleClick() {
    trackAnalytics({
      view:
        resultsType === RESULTS_TYPES.PUPPIES
          ? ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS
          : ANALYTICS_VIEWS.BREEDER_SEARCH_RESULTS
    });
  }

  return (
    <div className="BreederScreeningBanner flex-m flex-l md:gap-16 justify-between bg-sky pv12-lg pv6 ph18-lg ph5 br4">
      <div className="w-100 w-60-md">
        <h4 className="font-24 lg:font-32 mb4 mb8-lg lh-title">
          We’ve screened nearly every breeder in the U.S.—only 1 in 5 meet our
          standard for responsible breeding.
        </h4>
        <div className="hidden md:block">
          <a
            href={STANDARDS_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="BreederScreeningBanner__buttonCta stone-700 pv2 ph4 inline-flex items-center bg-white-40 br-pill"
            onClick={handleClick}
          >
            <p className="mr1 font-14 lg:font-16 lh-title">{LINK_COPY}</p>
            <Icon
              width="24px"
              height="24px"
              name="fetch-chevron-right"
              className="stone-700"
            />
          </a>
        </div>
      </div>
      <div className="w-100 w-30-md flex">
        <SmartImage
          src={IS_LT_LG ? breederGeoMobilePng : breederGeoDesktopPng}
          lazy
        />
      </div>
      <div className="md:hidden">
        <a
          href={STANDARDS_PATH}
          target="_blank"
          rel="noopener noreferrer"
          className="BreederScreeningBanner__buttonCta mt4 stone-700 w-100 pv2 ph4 inline-flex justify-between items-center bg-white-40 br-pill"
          onClick={handleClick}
        >
          <p className="mr1 font-14 lh-title">{LINK_COPY}</p>
          <Icon
            width="24px"
            height="24px"
            name="fetch-chevron-right"
            className="stone-700"
          />
        </a>
      </div>
    </div>
  );
}
